import { IconButton, Link, Menu, MenuItem } from '@chronosphereio/chrono-ui';
import { Link as LinkIcon } from 'mdi-material-ui';
import { useState } from 'react';
import { ContextLinkDefinition } from '../../../core';
import { useLinkTypeByUrl } from '../../../plugin-system';
import { useInterpolateContextLinkFn } from '../../../plugin-system/runtime/context-links';

type PanelLinksProps = {
  links?: ContextLinkDefinition[];
};

function PanelLink({ href, label, onClick }: { href: string; label: string; onClick: () => void }) {
  const linkType = useLinkTypeByUrl(href);

  return (
    <Link style={{ color: 'inherit' }} href={href} target="_blank" rel="noreferrer">
      <MenuItem Icon={linkType.Icon !== null ? linkType.Icon : undefined} onClick={onClick}>
        {label}
      </MenuItem>
    </Link>
  );
}

export function PanelLinks({ links = [] }: PanelLinksProps) {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(menuAnchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setMenuAnchorEl(null);
  };

  const interpolateContextLink = useInterpolateContextLinkFn();

  if (links.length === 0) return null;

  return (
    <>
      <IconButton onClick={handleClick} size="small" aria-haspopup="true" aria-label="Panel Links">
        <LinkIcon />
      </IconButton>

      <Menu anchorEl={menuAnchorEl} open={isOpen} onClose={handleClose}>
        {links.map((l, idx) => (
          <PanelLink key={idx} href={interpolateContextLink(l.spec.url)} label={l.spec.title} onClick={handleClose} />
        ))}
      </Menu>
    </>
  );
}
